<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "TransportOrderCtIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
